<template>
    <vue-simple-spinner
        v-if="loader"
        :size="size"
        :font-size="fontSize"
        :line-fg-color="lineForegroundColor"
        :line-bg-color="lineBackgroundColor"
        :message="showMessage ? $t('components.loading') : ''"
    />
</template>

<script>
import Spinner from 'vue-simple-spinner'

export default {
    name: 'Loader',
    components: {
        'vue-simple-spinner': Spinner,
    },
    props: {
        size: {
            type: Number,
            default: 32,
        },
        showMessage: {
            type: Boolean,
            default: true,
        },
        fontSize: {
            type: Number,
            default: 20,
        },
        lineForegroundColor: {
            type: String,
            default: '#2196f3',
        },
        lineBackgroundColor: {
            type: String,
            default: '#eee',
        },
        loader: {
            type: Boolean,
            default: false,
            required: true,
        },
    },
}
</script>
